import React, { useEffect, useState } from 'react';
import socket from '../utils/Socket';
import { BsQrCodeScan } from 'react-icons/bs';
import { FiCheckCircle, FiAlertCircle, FiSmartphone, FiRefreshCw, FiPower } from 'react-icons/fi';
import { ImSpinner2 } from 'react-icons/im';
import { FaWhatsapp } from 'react-icons/fa6';

const WhatsAppQRCode = () => {
    const [qrCode, setQrCode] = useState(null);
    const [status, setStatus] = useState('Esperando QR...');

    useEffect(() => {
        socket.emit('get-whatsapp-status');

        socket.on('whatsapp-status', (data) => {
            if (data.status === 'qr') {
                setQrCode(data.qr);
                setStatus('Escanea el código QR para conectar tu WhatsApp');
            } else if (data.status === 'ready') {
                setQrCode(null);
                setStatus('WhatsApp ya está conectado');
            } else {
                setStatus('Esperando código QR...');
            }
        });

        // Mismos listeners de antes
        socket.on('whatsapp-qr', (dataUrl) => {
            setQrCode(dataUrl);
            setStatus('Escanea el código QR para conectar tu WhatsApp');
        });

        socket.on('whatsapp-authenticated', () => {
            setQrCode(null);
            setStatus('WhatsApp autenticado correctamente');
        });

        socket.on('whatsapp-ready', () => {
            setQrCode(null);
            setStatus('📲 WhatsApp está listo');
        });

        socket.on('whatsapp-disconnected', (reason) => {
            setStatus(`WhatsApp desconectado: ${reason}`);
        });

        return () => {
            socket.off('whatsapp-status');
            socket.off('whatsapp-qr');
            socket.off('whatsapp-authenticated');
            socket.off('whatsapp-ready');
            socket.off('whatsapp-disconnected');
        };
    }, []);

    const handleCheckStatus = () => {
        socket.emit('get-whatsapp-status');
    };

    const handleDisconnect = () => {
        socket.emit('disconnect-whatsapp');
        setQrCode(null);
        setStatus('WhatsApp desconectado manualmente');
    };

    const getStatusIcon = () => {
        if (status.includes('QR')) return <BsQrCodeScan className="text-green-600 dark:text-green-400 text-4xl animate-pulse" />;
        if (status.includes('autenticado')) return <FiCheckCircle className="text-green-600 dark:text-green-400 text-4xl" />;
        if (status.includes('listo')) return <FiSmartphone className="text-green-600 dark:text-green-400 text-4xl" />;
        if (status.includes('ya está conectado')) return <FaWhatsapp className="text-green-600 dark:text-green-400 text-4xl" />;
        if (status.includes('desconectado')) return <FiAlertCircle className="text-red-500 dark:text-red-400 text-4xl" />;
        if (status.includes('Esperando')) return <ImSpinner2 className="text-yellow-500 dark:text-yellow-400 text-4xl animate-spin" />;
        return null;
    };

    return (
        <div className="flex flex-col items-start gap-6 p-6 max-w-xl w-full 
  bg-gradient-to-br from-white via-green-50 to-white dark:from-brand-900 dark:via-brand-950 dark:to-brand-900
  rounded-2xl shadow-xl transition-colors mx-auto
">
            <div className="flex flex-col items-center text-center gap-4 w-full">
                <div className="text-green-600 dark:text-green-400 text-5xl drop-shadow-sm">
                    {getStatusIcon()}
                </div>

                <h2 className="text-2xl sm:text-3xl font-normal tracking-wide 
    text-green-700 dark:text-green-300 
    font-sans drop-shadow-sm transition-colors duration-300"
                >
                    {status}
                </h2>
            </div>

            {qrCode ? (
                <div className="w-full flex justify-center">
                    <div className="p-3 bg-white dark:bg-gray-800 rounded-xl shadow-lg ring-4 ring-green-300 dark:ring-green-600">
                        <img
                            src={qrCode}
                            alt="Código QR de WhatsApp"
                            className="w-64 h-64 object-contain rounded-md"
                        />
                    </div>
                </div>
            ) : status === 'Esperando código QR...' ? (
                <p className="text-green-600 dark:text-green-400 italic">
                    Esperando código QR...
                </p>
            ) : null}

            <div className="flex flex-col sm:flex-row w-full gap-4 mt-6">
                <button
                    onClick={handleCheckStatus}
                    className="flex items-center justify-center gap-3 flex-1 min-h-[65px] px-6 py-3
      text-white bg-gradient-to-r from-green-500 to-green-700
      hover:from-green-600 hover:to-green-800 active:scale-95
      rounded-xl font-semibold text-lg shadow-md transition-all duration-300
      dark:from-green-400 dark:to-green-600 dark:hover:from-green-500 dark:hover:to-green-700"
                >
                    <FiRefreshCw className="text-2xl" />
                    Verificar estado
                </button>

                <button
                    onClick={handleDisconnect}
                    className="flex items-center justify-center gap-3 flex-1 min-h-[65px] px-6 py-3
      text-white bg-gradient-to-r from-red-500 to-red-700
      hover:from-red-600 hover:to-red-800 active:scale-95
      rounded-xl font-semibold text-lg shadow-md transition-all duration-300
      dark:from-red-400 dark:to-red-600 dark:hover:from-red-500 dark:hover:to-red-700"
                >
                    <FiPower className="text-2xl" />
                    Desconectar
                </button>
            </div>

        </div>


    );
};

export default WhatsAppQRCode;
